import { ApplicationState } from '../reducers';
import { getSessionRole, getSessionContextType } from './index';

// The three portals served by this single bims-web app, distinguished at
// runtime by hostname. `null` means "this session has no legitimate
// bims-web portal" (e.g. global staff who belong in the separate admin
// portal, or applicants who only use the anonymous scheduler flow).
export type Portal = 'scheduler' | 'network' | 'bims';

// Pure mapping from a session's JWT claims to the portal that session is
// allowed to use. Kept free of redux/DOM so it is trivially unit-testable.
//
// Rules (locked with leadership 2026-06-18):
//   - context_type 'livescanvendor' -> scheduler (LSV Dashboard)
//   - context_type 'network'        -> network admin
//   - context_type 'employer'       -> bims (employer/LSV dashboard)
//   - role 'admin' / 'bim_staff'    -> none (they use the global admin
//                                            portal + Django admin only)
//   - role 'user' with no context   -> none (applicants: anon flow only)
export function homePortalForSession(
    role: string | null,
    contextType: string | null,
): Portal | null {
    if (role === 'admin' || role === 'bim_staff') {
        return null;
    }
    switch (contextType) {
        case 'livescanvendor':
            return 'scheduler';
        case 'network':
            return 'network';
        case 'employer':
            return 'bims';
        default:
            return null;
    }
}

// The portal the current hostname corresponds to. Mirrors the detection in
// Routes.tsx (substring match on the hostname).
export function portalForHostname(hostName: string): Portal {
    if (hostName.indexOf('network') >= 0) {
        return 'network';
    }
    if (hostName.indexOf('scheduler') >= 0) {
        return 'scheduler';
    }
    return 'bims';
}

export const getSessionHomePortal = (state: ApplicationState): Portal | null =>
    homePortalForSession(getSessionRole(state), getSessionContextType(state));
